const englishTable = `<table id="haul_id_shp" style="color: #222831; padding: 3px;">
  <tr style = "background-color: #e9ecef;" >
    <th colspan="2" style="padding: 12px;">Quote Number: haul_id_shp</th>
  </tr>
  <tr>
    <td style="padding: 8px; font-weight: bold;">Origin Zip Code: </td>
    <td style="padding: 8px;">origin_zip_code_table</td>
  </tr>
  <tr>
    <td style="padding: 8px; font-weight: bold;">Destination Zip Code: </td>
    <td style="padding: 8px;">destination_zip_code_table</td>
  </tr>
  <tr>
    <td style="padding: 8px; font-weight: bold;">Number of pieces: </td>
    <td style="padding: 8px;">number_of_pieces_table</td>
  </tr>
  <tr>
    <td style="padding: 8px; font-weight: bold;">Dimensions (inches): </td>
    <td style="padding: 8px;">all_dimensions_table</td>
  </tr>
  <tr>
    <td style="padding: 8px; font-weight: bold;">Total Weight (Lbs): </td>
    <td style="padding: 8px;">total_weight_table</td>
  </tr>
  <tr>
    <td style = "padding: 8px; font-weight: bold;">Volume(Cubic Feet): </td>
    <td style = "padding: 8px;">cubic_feet_table</td>
  </tr>
  <tr>
    <td style = "padding: 8px; font-weight: bold;">Commodity: </td>
    <td style = "padding: 8px;">all_commodity_table</td>
  </tr>
  <tr>
    <td style="padding: 8px; font-weight: bold;">Accessorials: </td>
    <td style="padding: 8px;">all_accessorials_table</td>
  </tr>
  <tr>
    <td style="padding: 8px; font-weight: bold;">Linear feet: </td>
    <td style="padding: 8px;">linear_feet_table</td>
  </tr>
</table>`;

export default englishTable;
